import type { Section } from '~support-at-home/models';

/**
 * Cascades a new budget end date to all section items whose end_date currently matches
 * the original budget end date. Items with a custom end date (i.e. already diverging
 * from the original) are left untouched.
 *
 * This is a pure function extracted from BudgetEdit.tsx so that the cascade logic
 * can be unit-tested independently of the Formik component.
 */
export const cascadeEndDateToItems = (
  sections: Section[],
  originalEndDate: string | null,
  newEndDate: string,
): Section[] => {
  if (!originalEndDate) return sections;

  return sections.map((section) => ({
    ...section,
    items: section.items.map((item) =>
      item.end_date === originalEndDate ? { ...item, end_date: newEndDate } : item,
    ),
  }));
};
